import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useContext, useMemo, useRef } from 'react';
import isNil from 'lodash/isNil';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import configure from 'choerodon-ui/lib/configure';
import { ThemeContext, isEmpty, EUedThemeName } from '../utils';
import { useLoadingEl } from '../ComponentsUtils/useLoadingEl'; // 用于解决 UED 各主题数据优先级问题

var C7nConfigProvider = function C7nConfigProvider(_ref) {
  var children = _ref.children;
  var beforeSchema = useRef();
  var _useContext = useContext(ThemeContext),
    schema = _useContext.schema,
    _useContext$resolvedT = _useContext.resolvedTheme,
    resolvedTheme = _useContext$resolvedT === void 0 ? {} : _useContext$resolvedT;
  var isTheme1 = resolvedTheme.__uedThemeName__ === EUedThemeName.theme1;
  var isTheme2 = resolvedTheme.__uedThemeName__ === EUedThemeName.theme2;
  var isTheme5 = resolvedTheme.__uedThemeName__ === EUedThemeName.theme5;
  var circle = useLoadingEl();
  var _useContext2 = useContext(ConfigContext),
    getConfig = _useContext2.getConfig;
  var defaultConfigValue = useMemo(function () {
    var defaultValue = {}; // 注：后面设置的全局配置，都需要在这里获取默认值，切换主题需要默认值

    defaultValue.labelLayout = getConfig('labelLayout');
    defaultValue.labelAlign = getConfig('labelAlign');
    defaultValue.useColon = getConfig('useColon');
    defaultValue.tableRowHeight = getConfig('tableRowHeight');
    defaultValue.tableParityRow = getConfig('tableParityRow');
    defaultValue.tableSpinProps = getConfig('tableSpinProps');
    defaultValue.tableBorder = getConfig('tableBorder');
    defaultValue.tableColumnEditorBorder = getConfig('tableColumnEditorBorder');
    return defaultValue;
  }, [getConfig]);
  var configValue = {}; // FormPro labelLayout

  if (!isEmpty(schema, resolvedTheme) && !isTheme2 && resolvedTheme.input && !isNil(resolvedTheme.input.layout)) {
    configValue.labelLayout = resolvedTheme.input.layout;
  } // FormPro labelAlign

  if (!isEmpty(schema, resolvedTheme) && !isTheme2 && resolvedTheme.input && !isNil(resolvedTheme.input.labelAlign)) {
    // @ts-ignore
    configValue.labelAlign = resolvedTheme.input.labelAlign;
  } // FormPro useColon

  if (!isEmpty(schema, resolvedTheme) && !isTheme2 && resolvedTheme.input && !isNil(resolvedTheme.input.formUseColon)) {
    configValue.useColon = resolvedTheme.input.formUseColon;
  } // TablePro rowHeight

  if (resolvedTheme.table && !isNil(resolvedTheme.table.rowHeight)) {
    configValue.tableRowHeight = resolvedTheme.table.rowHeight;
  } // TablePro parityRow

  if (resolvedTheme.table && !isNil(resolvedTheme.table.striped)) {
    configValue.tableParityRow = resolvedTheme.table.striped;
  } // TablePro tableSpinProps

  var tableSpinProps = getConfig('tableSpinProps');
  if (tableSpinProps) {
    // @ts-ignore
    tableSpinProps.indicator = circle;
    configValue.tableSpinProps = tableSpinProps;
  } else {
    configValue.tableSpinProps = {
      indicator: circle
    };
  } // TablePro border

  if (isTheme1 || isTheme5) {
    configValue.tableBorder = false;
    configValue.tableColumnEditorBorder = true;
  }
  if (!beforeSchema.current || beforeSchema.current !== schema) {
    configure(_objectSpread(_objectSpread({}, defaultConfigValue), configValue));
  }
  beforeSchema.current = schema;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default C7nConfigProvider;